import { render, staticRenderFns } from "./CustomerManagement.vue?vue&type=template&id=76c9201a&scoped=true&"
import script from "./CustomerManagement.vue?vue&type=script&lang=js&"
export * from "./CustomerManagement.vue?vue&type=script&lang=js&"
import style0 from "./CustomerManagement.vue?vue&type=style&index=0&id=76c9201a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c9201a",
  null
  
)

export default component.exports